import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import {
  RoutedTabbedSectionCard,
  RoutedTabbedSectionSwitch,
} from 'dashboard/components/TabbedSectionV2';
import { RoutedTabbedSectionCardChild } from 'dashboard/components/TabbedSectionV2/RoutedTabbedSection';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { ProductFeatureName } from 'dashboard/models/organization';
import DashboardOrganizationBillingInvoicesRoute from 'dashboard/routes/DashboardOrganizationBillingInvoicesRoute/DashboardOrganizationBillingInvoicesRoute';
import DashboardOrganizationBillingOverviewRoute from 'dashboard/routes/DashboardOrganizationBillingOverviewRoute/DashboardOrganizationBillingOverviewRoute';
import DashboardOrganizationBillingPaymentRoute from 'dashboard/routes/DashboardOrganizationBillingPaymentRoute/DashboardOrganizationBillingPaymentRoute';
import DashboardOrganizationCurrentUsageRoute from 'dashboard/routes/DashboardOrganizationCurrentUsageRoute/DashboardOrganizationCurrentUsageRoute';
import useProductFeature from 'lib/hooks/useProductFeature';

enum BillingViewTabs {
  Overview = 'overview',
  CurrentUsage = 'current-usage',
  PastInvoices = 'past-invoices',
  PaymentMethod = 'payment-method',
}

type BillingSwitchTab = {
  path: string;
  contents: JSX.Element;
};

type BillingViewTab = {
  card: RoutedTabbedSectionCardChild;
  switch: BillingSwitchTab;
};

const TABS_MAP: Record<BillingViewTabs, BillingViewTab> = {
  [BillingViewTabs.Overview]: {
    card: {
      name: 'Overview',
      path: 'overview',
      dataTest: 'billing-view__tab--overview',
    },
    switch: {
      path: 'overview',
      contents: <DashboardOrganizationBillingOverviewRoute />,
    },
  },
  [BillingViewTabs.CurrentUsage]: {
    card: {
      name: 'Current Usage',
      path: 'current-usage',
      dataTest: 'billing-view__tab--current-usage',
    },
    switch: {
      path: 'current-usage',
      contents: <DashboardOrganizationCurrentUsageRoute />,
    },
  },
  [BillingViewTabs.PastInvoices]: {
    card: {
      name: 'Invoices',
      path: 'invoices',
      dataTest: 'billing-view__tab--invoices',
    },
    switch: {
      path: 'invoices',
      contents: <DashboardOrganizationBillingInvoicesRoute />,
    },
  },
  [BillingViewTabs.PaymentMethod]: {
    card: {
      name: 'Payment Method',
      path: 'payment',
      dataTest: 'billing-view__tab--payment',
    },
    switch: {
      path: 'payment',
      contents: <DashboardOrganizationBillingPaymentRoute />,
    },
  },
};

const DashboardOrganizationBillingView = () => {
  const currentInvoiceProductFeatureEnabled = useProductFeature(
    ProductFeatureName.BillingDashboardCurrentInvoice,
  );

  let tabOrder = [
    BillingViewTabs.Overview,
    BillingViewTabs.PastInvoices,
    BillingViewTabs.PaymentMethod,
  ];

  if (currentInvoiceProductFeatureEnabled) {
    tabOrder = [
      BillingViewTabs.Overview,
      BillingViewTabs.CurrentUsage,
      BillingViewTabs.PastInvoices,
      BillingViewTabs.PaymentMethod,
    ];
  }

  const cardTabs: RoutedTabbedSectionCardChild[] = tabOrder.map((tabName) => {
    return TABS_MAP[tabName].card;
  });
  const switchTabs = tabOrder.map((tabName) => {
    return TABS_MAP[tabName].switch;
  });

  return (
    <>
      <InactiveEnvironmentBanner />
      <Container>
        <Header title='Billing' />
        <Section>
          <RoutedTabbedSectionCard tabs={cardTabs} />
          <RoutedTabbedSectionSwitch tabs={switchTabs} />
        </Section>
      </Container>
    </>
  );
};
export default DashboardOrganizationBillingView;
